import CancelShipmentButton from './CancelShipmentButton';
import React, { useState } from "react";
import "./CancellationDialog.css";

export default function CancellationDialog({ record, busy, error, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const completed = record.durum !== "DOKUM_BEKLIYOR";
  return <div className="shipment-modal"><section className="cimento-card" role="dialog" aria-modal="true" aria-labelledby="cimento-cancel-title">
    <h2 id="cimento-cancel-title">Kaydı İptal Et</h2>
    <p>{record.plaka} · {record.seriNo} · {record.dolumTarihi}</p>
    <p>Kayıt geçmişte saklanır. Seri ve irsaliye numaraları yeniden kullanılabilir.</p>
    {completed && <p>Sefer; tonaj, sipariş ve bağlantı kullanımından ve raporlardan çıkarılacak.</p>}
    <form onSubmit={event => { event.preventDefault(); if (!busy && (!completed || reason.trim())) onConfirm(reason.trim()); }}>
      <label>{completed ? "İptal gerekçesi (zorunlu)" : "İptal gerekçesi (isteğe bağlı)"}<textarea required={completed} maxLength={1000} value={reason} onChange={event => setReason(event.target.value)} disabled={busy} /></label>
      {error && <p role="alert">{error}</p>}
      <div className="cimento-cancel-actions"><button type="button" disabled={busy} onClick={onClose}>Vazgeç</button><CancelShipmentButton type="submit" disabled={busy || (completed && !reason.trim())}>{busy ? "İptal ediliyor..." : "Kaydı İptal Et"}</CancelShipmentButton></div>
    </form>
  </section></div>;
}
